<template>
  <Autocomplete
  v-model="sportIDs"
  :items="$store.getters.sportValues"
  :label="label || 'Sport'"
  :multiple="multiple"
  item-text="labels.default"
  :placeholder="placeholder || 'Sport'"
  :item-value="'id'"
  v-bind="$attrs"
  clearable
  />
</template>

<script>
import Autocomplete from '@/components/forms/Autocomplete.vue'

export default {
  name: 'SportSelector',
  components: {
    Autocomplete
  },
  props: {
    currentSportIDs: {
      type: [Array, String],
      default: () => undefined
    },
    label: String,
    placeholder: String,
    multiple: Boolean
  },
  computed: {
    sportIDs: {
      get () {
        return this.currentSportIDs
      },
      set (newVal) {
        this.$emit('sportSelected', newVal || '')
      }
    }
  },
  methods: {
    clear () {
      this.sportIDs = undefined
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/common/SportSelector.vue